import React, {Component} from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import '@fortawesome/fontawesome-free-solid';

class About extends Component {
    render() {
        return (
            <div className="uk-text-justify">
                <h3 className="uk-text-uppercase uk-text-bold">About Me</h3>
                <div className="uk-animation-slide-top-small">
                    <div className="uk-text-center">
                        <img className="uk-border-circle" src="./images/sajid.jpg" width="200" height="200" alt="Border circle"/>
                        <h3 className="uk-text-uppercase uk-margin-remove-bottom uk-text-bold uk-text-lead">Sajid Mohammed</h3>
                        <h4 className="uk-margin-remove-top">Fullstack Web Developer</h4>
                    </div>
                    <p>From all my experience I've been developing applications for the web using mostly HTML5, CSS3, Javascript and PHP. My job involves doing what I love, Developing new websites/applications and developing fantastic content management systems(CMS). I find keeping involved helps me stay up to date. I regularly follow the tech and developers blog's to keep the new technologies update.</p>
                    <p>I spend a lot of time learning new techniques and actively help other people learn web development through a variety of help groups and writing blog about web design and development.</p>
                    <p className="uk-margin-remove-bottom"><FontAwesomeIcon icon="globe"/> I handle all parts of website development from domain registration, hosting, website development and website maintenance.</p>
                    <p className="uk-margin-remove-vertical"><FontAwesomeIcon icon="database"/> MySQL and PHP for database driven websites</p>
                    <p className="uk-margin-remove-vertical"><FontAwesomeIcon icon="desktop"/> I build CMS websites and use open source applications like Drupal, WordPress, Laravel, and Symfony.</p>
                    <p className="uk-margin-remove-top"><FontAwesomeIcon icon="code"/> Most websites I build can be created with Drupal content management system.</p>
                    <hr/>
                    <p className="uk-margin-remove-bottom"><FontAwesomeIcon icon="phone-square"/> Phone: 669-***-****</p>
                    <p className="uk-margin-remove-vertical"><FontAwesomeIcon icon="at"/> Email: sajid.***@*****.com</p>
                    <p className="uk-margin-remove-vertical"><FontAwesomeIcon icon="address-card"/> Address: Bentonville, Arkansas 72712</p>
                    <h4>What i'm Doing</h4>
                    <div uk-grid="true">
                        <div className="uk-width-1-1 uk-width-1-2@s uk-width-1-4@m uk-width-1-4@l uk-width-1-4@xl">
                            <div className="uk-card uk-card-default uk-card-body uk-card-hover">
                                <div className="uk-text-center">
                                    <FontAwesomeIcon className="fa-4x uk-text-primary" icon="desktop"/>
                                    <p className="uk-margin-remove-bottom">Web Applications</p>
                                </div>
                            </div>
                        </div>
                        <div className="uk-width-1-1 uk-width-1-2@s uk-width-1-4@m uk-width-1-4@l uk-width-1-4@xl">
                            <div className="uk-card uk-card-default uk-card-body uk-card-hover">
                                <div className="uk-text-center">
                                    <FontAwesomeIcon className="fa-4x uk-text-primary" icon="mobile-alt"/>
                                    <p className="uk-margin-remove-bottom">Responsive Design</p>
                                </div>
                            </div>
                        </div>
                        <div className="uk-width-1-1 uk-width-1-2@s uk-width-1-4@m uk-width-1-4@l uk-width-1-4@xl">
                            <div className="uk-card uk-card-default uk-card-body uk-card-hover">
                                <div className="uk-text-center">
                                    <FontAwesomeIcon className="fa-4x uk-text-warning" icon="image"/>
                                    <p className="uk-margin-remove-bottom">Designing</p>
                                </div>
                            </div>
                        </div>
                        <div className="uk-width-1-1 uk-width-1-2@s uk-width-1-4@m uk-width-1-4@l uk-width-1-4@xl">
                            <div className="uk-card uk-card-default uk-card-body uk-card-hover">
                                <div className="uk-text-center">
                                    <FontAwesomeIcon className="fa-4x uk-text-success" icon="level-up-alt"/>
                                    <p className="uk-margin-remove-bottom">Updating Skills</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default About;



// WEBPACK FOOTER //
// src/components/About.js